import { poll } from 'lib/poll';
import * as operations from 'lib/graphql/queries';
import { millisecond } from 'config/constants';
import { LatestRef } from './types';

export const acceptQuote = async (ref: LatestRef) => {
  const { client, setState } = ref.current;
  const bookingId = ref.current.booking!.id;
  const amendmentId = ref.current.amendment!.id;

  setState((state) => ({ ...state, stage: 'PROCESSING' }));

  await operations.acceptAmendment(client, { variables: { bookingId, amendmentId } });

  const acceptedResult = await poll({
    requestFn: () => operations.getAmendment(client, { variables: { bookingId, amendmentId }, fetchPolicy: 'network-only' }),
    isFinished: (result) => result.data.amendment.state !== 'ACCEPTING',
    timeoutMs: millisecond.MINUTE * 3,
  });

  const { amendment } = acceptedResult.data;

  setState((state) => ({ ...state, stage: amendment.state === 'ACCEPTED' ? 'CONFIRMED' : 'REVIEW' }));
};
